import { PickerAbstract } from "./PickerAbstract";
import { AmpPlugin, DateTime, easepick, LockPlugin } from "@easepick/bundle";
import { Core } from "@easepick/core";
import { today } from "../../Modules/RentalAndAppointments/Helper/DateRangePicker";
import { getHolidays } from "../../Utils/Holidays";
import { regionsForHolidays } from "../../Modules/RentalAndAppointments/Config";
import { KeepSelectedDatePlugin } from "../../EasePick/keep-selected-date-plugin/KeepSelectedDatePlugin";

export class PickerDate extends PickerAbstract {
    declare easepick: Core;

    public createCalendar(id: string) {
        const holidays = getHolidays(regionsForHolidays, 400, today);
        this.createTrigger();
        // @ts-ignore
        this.easepick = new easepick.create({
            element: this.trigger,
            css: [this.cssPath],
            format: this.dateFormat,
            zIndex: 0,
            grid: 1,
            calendars: 1,
            inline: false,
            readonly: false,
            autoApply: false,
            scrollToDate: true,
            lang: this.lang,
            locale: {
                cancel: this.cancel,
                apply: this.apply
            },
            LockPlugin: {
                maxDate: this.max,
                minDate: this.min,
                filter: (date: DateTime) =>
                    (this.disableHolidays && date && date.inArray(holidays)) || date.inArray(this.locked)
            },
            // @ts-ignore
            AmpPlugin: {
                maxDate: this.max,
                minDate: this.min,
                dropdown: {
                    months: true,
                    years: true,
                    minYear: 1900
                },
                resetButton: true
            },
            KeepSelectedDatePlugin: {},
            plugins: [LockPlugin, AmpPlugin, KeepSelectedDatePlugin],
            setup: (picker: Core) => {
                picker.ui.wrapper.id = id;
            }
        });

        return this;
    }

    get locked() {
        return (
            this.getAttribute("data-locked")
                ?.split(",")
                .map((d) => new DateTime(d)) || []
        );
    }
}

customElements.define("x-date-picker", PickerDate);
